import { TCategoryName } from '../../glossary/utils/types';

export const categoryIds = [
  'investing',
  'economy',
  'personal_finance',
  'taxation',
  'business',
  'financial_advisor',
  'trading',
  'corporate_finance_and_accounting',
  'savings_wealth_management',
];

export const mockArticleData = {
  'Category': 'Category',
  'Subcategory': 'Subcategory',
  'H1-1': 'Investment',
  'Author': 'Mock',
  'SEO_term': 'investment',
  'SEO_Category': 'investment',
  'SEO_Subcategory': 'investment',
  'content_updated_at': 'Sep 30, 2023',
  'markdown': 'markdown',
  'markdown_headings': [
    {
      id: 'introduction',
      heading: 'Introduction',
    },
  ],
  'breadcrumbs': [
    {
      term: 'Investing',
      SEO_term: 'investing',
    },
  ],
};

export const categoryName: TCategoryName = {
  investing: 'Investing',
  economy: 'Economy',
  personal_finance: 'Personal Finance',
  taxation: 'Taxation',
  business: 'Business',
  financial_advisor: 'Financial Advisor',
  trading: 'Trading',
  corporate_finance_and_accounting: 'Corporate Finance And Accounting',
  savings_wealth_management: 'Savings/Wealth Management',
};

export const keywordArray = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const SocialIcon = [
  {
    id: 'facebook',
    icon: 'https://assets.clear.in/cleartax/images/1695725613_group181440182.png',
  },
  {
    id: 'twitter',
    icon: 'https://assets.clear.in/cleartax/images/1695725660_group181440201.png',
  },
  {
    id: 'linkedin',
    icon: 'https://assets.clear.in/cleartax/images/1695725698_group181440231.png',
  },
  {
    id: 'whatsapp',
    icon: 'https://assets.clear.in/cleartax/images/1695725742_group181440241.png',
  },
];

export const ArticleData = {
  title: 'Zoning',
  updated_at: 'Updated on Nov 22, 2023',
  permalink: '/zoning',
  content: '<p> zoning </p>',
  related_posts: null,
  popular_posts: null,
  interesting_posts: null,
  language: 1,
  domain: 1,
};

export const mockCardData = [
  {
    title: 'Zoning',
    updated_at: 'Updated on Nov 22, 2023',
    permalink: '/zoning',
    content: '<p> zoning </p>',
    description: 'Zoning',
  },
];

export const CATEGORY_TREE = {
  result: [
    {
      parentCategory: 'Investing',
      parentCategory_SEO_term: 'investing',
      subcategory: [
        {
          H1_1: 'Investing Essentials',
          SEO_term: 'investing-essentials',
        },
        {
          H1_1: 'Portfolio Management',
          SEO_term: 'portfolio-management',
        },
        {
          H1_1: 'Financial Technology',
          SEO_term: 'financial-technology',
        },
        {
          H1_1: 'Fundamental Analysis',
          SEO_term: 'fundamental-analysis',
        },
        {
          H1_1: 'Alternative Investments',
          SEO_term: 'alternative-investments',
        },
        {
          H1_1: 'Sustainable Investing',
          SEO_term: 'sustainable-investing',
        },
        {
          H1_1: 'Cryptocurrency',
          SEO_term: 'cryptocurrency',
        },
        {
          H1_1: 'Laws and Regulations',
          SEO_term: 'laws-and-regulations',
        },
        {
          H1_1: 'Mutual Funds',
          SEO_term: 'mutual-funds',
        },
        {
          H1_1: 'Stocks',
          SEO_term: 'stocks',
        },
        {
          H1_1: 'Etfs',
          SEO_term: 'etfs',
        },
        {
          H1_1: 'Bonds',
          SEO_term: 'bonds',
        },
        {
          H1_1: 'Markets',
          SEO_term: 'markets',
        },
        {
          H1_1: 'Brokers',
          SEO_term: 'brokers',
        },
        {
          H1_1: 'Bitcoin',
          SEO_term: 'bitcoin',
        },
        {
          H1_1: 'ETF (Exchange Traded Fund)',
          SEO_term: 'etf-exchange-traded-fund',
        },
      ],
    },
    {
      parentCategory: 'Personal Finance',
      parentCategory_SEO_term: 'personal-finance',
      subcategory: [
        {
          H1_1: 'Banking',
          SEO_term: 'banking',
        },
        {
          H1_1: 'Budgeting and saving',
          SEO_term: 'budgeting-and-saving',
        },
        {
          H1_1: 'Credit and debt',
          SEO_term: 'credit-and-debt',
        },
        {
          H1_1: 'Credit Card',
          SEO_term: 'credit-card',
        },
        {
          H1_1: 'Home ownership',
          SEO_term: 'home-ownership',
        },
        {
          H1_1: 'Financial fraud',
          SEO_term: 'financial-fraud',
        },
        {
          H1_1: 'Insurance',
          SEO_term: 'insurance',
        },
        {
          H1_1: 'Retirement Planning',
          SEO_term: 'retirement-planning',
        },
        {
          H1_1: 'Wealth',
          SEO_term: 'wealth',
        },
      ],
    },
    {
      parentCategory: 'Economy',
      parentCategory_SEO_term: 'economy',
      subcategory: [
        {
          H1_1: 'Government and  Policy',
          SEO_term: 'government-and-policy',
        },
        {
          H1_1: 'Monetary Policy',
          SEO_term: 'monetary-policy',
        },
        {
          H1_1: 'Fiscal Policy',
          SEO_term: 'fiscal-policy',
        },
        {
          H1_1: 'Economics',
          SEO_term: 'economics',
        },
      ],
    },
    {
      parentCategory: 'Financial Advisor',
      parentCategory_SEO_term: 'financial-advisor',
      subcategory: [
        {
          H1_1: 'Continuing Education',
          SEO_term: 'continuing-education',
        },
        {
          H1_1: 'Financial Advisor Careers',
          SEO_term: 'financial-advisor-careers',
        },
        {
          H1_1: 'Financial Planning',
          SEO_term: 'financial-planning',
        },
        {
          H1_1: 'Portfolio Construction',
          SEO_term: 'portfolio-construction',
        },
        {
          H1_1: 'Practice Management',
          SEO_term: 'practice-management',
        },
      ],
    },
    {
      parentCategory: 'Savings/Wealth Management',
      parentCategory_SEO_term: 'savings-wealth-management',
      subcategory: [
        {
          H1_1: 'Savings scheme',
          SEO_term: 'savings-scheme',
        },
        {
          H1_1: 'Real Estate',
          SEO_term: 'real-estate',
        },
      ],
    },
    {
      parentCategory: 'Trading',
      parentCategory_SEO_term: 'trading',
      subcategory: [
        {
          H1_1: 'Trading Skills & Essentials',
          SEO_term: 'trading-skills-essentials',
        },
        {
          H1_1: 'Technical Analysis',
          SEO_term: 'technical-analysis',
        },
        {
          H1_1: 'Options & Derivatives Trading',
          SEO_term: 'options-derivatives-trading',
        },
        {
          H1_1: 'Fund Trading',
          SEO_term: 'fund-trading',
        },
        {
          H1_1: 'Algorithmic Trading',
          SEO_term: 'algorithmic-trading',
        },
        {
          H1_1: 'Stock Trading',
          SEO_term: 'stock-trading',
        },
        {
          H1_1: 'Futures & Commodities Trading',
          SEO_term: 'futures-commodities-trading',
        },
        {
          H1_1: 'Fixed Income Trading',
          SEO_term: 'fixed-income-trading',
        },
        {
          H1_1: 'Forex & Currencies Trading',
          SEO_term: 'forex-currencies-trading',
        },
        {
          H1_1: 'Commodities',
          SEO_term: 'commodities',
        },
        {
          H1_1: 'Trading Strategies',
          SEO_term: 'trading-strategies',
        },
      ],
    },
    {
      parentCategory: 'Taxation',
      parentCategory_SEO_term: 'taxation',
      subcategory: [
        {
          H1_1: 'Indirect Tax',
          SEO_term: 'indirect-tax',
        },
        {
          H1_1: 'Direct Tax',
          SEO_term: 'direct-tax',
        },
        {
          H1_1: 'Income Tax',
          SEO_term: 'income-tax',
        },
        {
          H1_1: 'Charitable Donations',
          SEO_term: 'charitable-donations',
        },
        {
          H1_1: 'Tax Deductions / Credits',
          SEO_term: 'tax-deductions-credits',
        },
        {
          H1_1: 'Tax laws',
          SEO_term: 'tax-laws',
        },
      ],
    },
    {
      parentCategory: 'Corporate Finance and Accounting',
      parentCategory_SEO_term: 'corporate-finance-and-accounting',
      subcategory: [
        {
          H1_1: 'Mergers & Acquisitions',
          SEO_term: 'mergers-acquisitions',
        },
        {
          H1_1: 'Financial Analysis',
          SEO_term: 'financial-analysis',
        },
        {
          H1_1: 'Corporate Finance',
          SEO_term: 'corporate-finance',
        },
        {
          H1_1: 'Financial Statements',
          SEO_term: 'financial-statements',
        },
        {
          H1_1: 'Financial Ratios',
          SEO_term: 'financial-ratios',
        },
        {
          H1_1: 'Accounting',
          SEO_term: 'accounting',
        },
        {
          H1_1: 'Debt',
          SEO_term: 'debt',
        },
        {
          H1_1: 'Corporate Insurance',
          SEO_term: 'corporate-insurance',
        },
        {
          H1_1: 'Wealth Management',
          SEO_term: 'wealth-management',
        },
      ],
    },
    {
      parentCategory: 'Business',
      parentCategory_SEO_term: 'business',
      subcategory: [
        {
          H1_1: 'Business Essentials',
          SEO_term: 'business-essentials',
        },
        {
          H1_1: 'Marketing Essentials',
          SEO_term: 'marketing-essentials',
        },
        {
          H1_1: 'Business Leaders',
          SEO_term: 'business-leaders',
        },
        {
          H1_1: 'Small Business',
          SEO_term: 'small-business',
        },
        {
          H1_1: 'Company Profiles',
          SEO_term: 'company-profiles',
        },
      ],
    },
  ],
  message: 'success',
};

export const GLOSSARY_SCHEMA = {
  title: 'FinTech Glossary - The Complete Financial Guide - ClearTax',
  metaDesc:
    'FinTech Glossary is a complete financial guide to understanding the FinTech terms like taxation, personal finance, investments, trading, economy, and more.',
  url: 'https://cleartax.in/glossary',
  datePublished: '2023-11-03T17:15:36.534000+05:30',
  dateModified: '2023-11-06T10:57:15.605000+05:30',
  productType: 'Glossary',
  logoUrl:
    'https://assets1.cleartax-cdn.com/cleartax-brand/logos/cleartax-logo-vertical-600x60-2017.png',
};
export const GLOSSARY_LIST_SCHEMA = (queryParam: string) => {
  return {
    title: `The FinTech terms beginning with ${queryParam}- ClearTax`,
    url: `https://cleartax.in/glossary/${queryParam?.toUpperCase()}/index/`,
    productType: `Glossary Category ${queryParam?.toUpperCase()}`,
  };
};
